import React from 'react';
import { FileText, Truck } from 'lucide-react';

/**
 * Компонент секции для перевода документов и доставки
 */
const DocumentSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-cyan-50 dark:bg-cyan-900/20 p-4 rounded-lg border border-cyan-100 dark:border-cyan-800">
      <h3 className="text-base font-medium text-gray-800 dark:text-gray-200 mb-4 flex items-center">
        <FileText className="w-5 h-5 mr-2 text-cyan-500" />
        Перевод документов и доставка
      </h3>
      
      <div className="grid grid-cols-1 gap-4">
        {/* Перевод документов */}
        {formData.includeTranslation && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="documentCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Количество документов для перевода
              </label>
              <input
                type="text"
                id="documentCount"
                name="documentCount"
                value={formData.documentCount}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.documentCount ? 'input-error' : ''}`}
                placeholder="Введите количество"
              />
              {errors.documentCount && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.documentCount}
                </p>
              )}
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                Средняя стоимость перевода 1 документа: 650-800 руб.
              </p>
            </div>
            
            <div className="bg-white dark:bg-gray-800 p-3 rounded-lg border border-gray-200 dark:border-gray-700">
              <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-2">
                Документы, требующие перевода:
              </h4>
              <ul className="text-xs text-gray-600 dark:text-gray-400 space-y-1">
                <li>• Паспорт (первая страница и страница с пропиской)</li>
                <li>• Справка с места работы</li>
                <li>• Выписка с банковского счета</li>
                <li>• Свидетельства о рождении/браке</li>
                <li>• Документы на недвижимость</li>
                <li>• Приглашения и спонсорские письма</li>
              </ul>
            </div>
          </div>
        )}
        
        {/* Доставка документов */}
        {formData.includeDelivery && (
          <div className="mt-4 pt-4 border-t border-cyan-200 dark:border-cyan-800">
            <div className="flex items-center mb-3">
              <Truck className="w-5 h-5 mr-2 text-cyan-500" />
              <h4 className="text-base font-medium text-gray-800 dark:text-gray-200">
                Доставка готовых документов
              </h4>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="deliveryType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Тип доставки
                </label>
                <select
                  id="deliveryType"
                  name="deliveryType"
                  value={formData.deliveryType}
                  onChange={handleInputChange}
                  className={`form-select w-full ${errors.deliveryType ? 'input-error' : ''}`}
                >
                  <option value="standard">Стандартная (3-5 дней)</option>
                  <option value="express">Экспресс (1-2 дня)</option>
                  <option value="courier">Курьерская (в день готовности)</option>
                  <option value="international">Международная доставка</option>
                </select>
                {errors.deliveryType && (
                  <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                    {errors.deliveryType}
                  </p>
                )}
              </div>
              
              <div className="grid grid-cols-2 gap-2">
                <div className="bg-gray-50 dark:bg-gray-700/30 p-2 rounded-lg border border-gray-200 dark:border-gray-700 text-center">
                  <div className="text-xs text-gray-500 dark:text-gray-400">Стандартная</div>
                  <div className="font-medium text-gray-800 dark:text-gray-200">450 ₽</div>
                </div>
                <div className="bg-gray-50 dark:bg-gray-700/30 p-2 rounded-lg border border-gray-200 dark:border-gray-700 text-center">
                  <div className="text-xs text-gray-500 dark:text-gray-400">Экспресс</div>
                  <div className="font-medium text-gray-800 dark:text-gray-200">850 ₽</div>
                </div>
                <div className="bg-gray-50 dark:bg-gray-700/30 p-2 rounded-lg border border-gray-200 dark:border-gray-700 text-center">
                  <div className="text-xs text-gray-500 dark:text-gray-400">Курьерская</div>
                  <div className="font-medium text-gray-800 dark:text-gray-200">1500 ₽</div>
                </div>
                <div className="bg-gray-50 dark:bg-gray-700/30 p-2 rounded-lg border border-gray-200 dark:border-gray-700 text-center">
                  <div className="text-xs text-gray-500 dark:text-gray-400">Международная</div>
                  <div className="font-medium text-gray-800 dark:text-gray-200">3500 ₽</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Информационный блок, если не выбрана ни одна опция */}
        {!formData.includeTranslation && !formData.includeDelivery && (
          <div className="text-center p-4 bg-white dark:bg-gray-800 rounded-lg border border-dashed border-gray-300 dark:border-gray-600">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Выберите дополнительные услуги в разделе "Дополнительные услуги" выше для отображения деталей
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentSection;